import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { ProductWishlistResponse, Product } from "@core/types";
import { productsClient } from "@core/clients";
import { queryClient } from "../../config/query-client";

type UpdateProductsWishlistParams = {
  productIds: Product["id"][];
};

type UpdateProductsWishlistQuery = {
  options?: UseMutationOptions<ProductWishlistResponse, any, UpdateProductsWishlistParams, [string, Product["id"]]>;
};

const useUpdateProductsWishlist = ({ options }: UpdateProductsWishlistQuery = {}) => {
  return useMutation(
    ["update-products-wishlist"],
    async ({ productIds }: UpdateProductsWishlistParams) => {
      return await productsClient.updateProductsWishlist(productIds);
    },
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries({queryKey: ["get-wishlist"]});
        options?.onSuccess?.(data, variables, context);
      },
      ...options,
    },
  );
};

export default useUpdateProductsWishlist;
